module.exports = __webpack_public_path__ + "img/doctor-avatar.5e9e7295.svg";